import * as bootstrap from 'bootstrap';
import $ from 'jquery';
import QRCode from 'qrcode';

import { identifyUser, resetUser } from '@shared/js/analytics.js';
import { APP_VERSION } from '@shared/js/instance.js';
import { v1BaseUrl } from './config.js';
import { applyRoute, renderLibraryRoute, resetRouteCache } from '/js/router.js';
import { loader, showLoader, hideLoader } from '/js/navigation.js';
import { markLibraryRendered } from '/main.js';
import { mkToast, escapeHtml } from '@shared/js/toasts.js';
import { renderAnnouncements } from '@shared/js/announcements.js';

export var userData = {};

// Detect if the current browser is likely on a mobile device
function isMobileDevice() {
  const ua = (navigator.userAgent || navigator.vendor || '').toLowerCase();
  return /iphone|ipad|android|mobile/.test(ua);
}

export function authStatus(callback) {
  $.ajax({
        url: v1BaseUrl + "account/session",
        type: "GET",
        svErrorMode: 'none',
        xhrFields: {
          withCredentials: true
        },
        success: function (data) {
          let status = data.status;
          callback(data.status);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.error("Error: " + textStatus, errorThrown);
          if (jqXHR.status === 401) {
            callback(false); // Not logged in
          } else {
            callback(true); // Avoid losing state during temporary outage
          }
        },
  });
}

function showAlert(message, alertType = 'danger') {
  const alert = $(`<div class="alert alert-${alertType} alert-dismissible fade show mt-3" role="alert">
	${message}
	<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  </div>`);
  $('#authPrompt .alert').remove(); // Remove any existing alert
  $('#authPrompt').prepend(alert); // Prepend the new alert
}

function removeAlert() {
	$('#authPrompt .alert').remove();
}

export function promptSignIn(authCode = null) {
  var appContainer = $('#app');
  // The sign-in prompt replaces the whole app outside the router — reset the
  // router's cache (and flush any active player) so the post-login
  // applyRoute() re-renders whatever the URL points at.
  resetRouteCache();
  appContainer.empty();

  var container = $('<div class="container">');
  var row = $('<div class="row justify-content-center mt-5 ms-2 me-2">');
  var col = $('<div class="col-md-6 p-4 bg-dark rounded-4 shadow" style="max-width: 400px;">');
  
  var logoContainer = $('<div class="d-flex justify-content-center mb-4">');
  
  const imagePath = new URL('@shared/media/StageVault.png', import.meta.url);

  var logo = $(`<img src="${imagePath}" class="w-75"/>`);
  logoContainer.append(logo);

  var nav = $('<ul class="nav nav-tabs mb-3" role="tablist">');
  var loginNavItem = $('<li class="nav-item" role="presentation">');
  var loginNavLink = $('<a class="nav-link active" id="login-tab" data-bs-toggle="tab" href="#login" role="tab">Login</a>');
  var signUpNavItem = $('<li class="nav-item" role="presentation">');
  var signUpNavLink = $('<a class="nav-link" id="sign-up-tab" data-bs-toggle="tab" href="#sign-up" role="tab">Sign Up</a>');

  var tabContent = $('<div class="tab-content">');
  var alertContainer = $('<div id="authPrompt">');
  var loginTab = $('<div class="tab-pane fade show active" id="login" role="tabpanel">');
  var signUpTab = $('<div class="tab-pane fade" id="sign-up" role="tabpanel">');

  // Login form
  var loginForm = $('<form class="mb-0"></form>');
  var loginEmailInput = $('<input type="text" class="form-control mb-2" autocomplete="email" placeholder="Email" required>');
  var loginPasswordInput = $('<input type="password" class="form-control mb-3" autocomplete="current-password" placeholder="Password" required>');
  var loginButton = $('<button type="submit" class="btn btn-primary w-100 ">Log In</button>');
  var forgotPasswordLink = $('<a href="#" class="mt-3 d-block text-light w-100 text-center">Forgot Password?</a>');
  var deviceLoginLink = null;
  if (!isMobileDevice()) {
    deviceLoginLink = $('<a href="#" class="mt-1 d-block text-light w-100 text-center">Sign in from another device</a>');
  }

  if (authCode) {
    const safeCode = escapeHtml(authCode);
    loginTab.append(`<div id="deviceAuthNotice" class="card card-body text-center mb-3">Log in to authorize device <strong>${safeCode}</strong></div>`);
  }

  loginForm.append(loginEmailInput, loginPasswordInput, loginButton, forgotPasswordLink);
  if (deviceLoginLink) {
    loginForm.append(deviceLoginLink);
  }
  
  // Sign up form
  var signUpForm = $('<form class="mb-0"></form>');
  var signUpFirstNameInput = $('<input type="text" class="form-control mb-2" autocomplete="given-name" placeholder="First Name" required>');
  var signUpLastNameInput = $('<input type="text" class="form-control mb-2" autocomplete="family-name" placeholder="Last Name" required>');
  var signUpEmailInput = $('<input type="text" class="form-control mb-2" autocomplete="email" placeholder="Email" required>');
  var signUpPasswordInput = $('<input type="password" class="form-control mb-3" autocomplete="new-password" placeholder="Password" required>');
  // Terms agreement checkbox
  var signUpTermsAgreement = $(`
	<div class="form-check mb-3">
	  <input type="checkbox" class="form-check-input" id="termsAgreement" required>
	  <label class="form-check-label" for="termsAgreement">
		I have read and agree to the <a href="/legal/privacy-policy" target="_blank">Privacy Policy</a> and <a href="/legal/terms-of-use" target="_blank">Terms of Use</a>.
	  </label>
	</div>
  `);
  var signUpButton = $('<button type="submit" class="btn btn-primary w-100">Sign Up</button>');
  signUpForm.append(signUpFirstNameInput, signUpLastNameInput, signUpEmailInput, signUpPasswordInput, signUpTermsAgreement, signUpButton);
  
  let clientInfo = $(`<span class="mt-4 text-center">Created by Devin Baeten<br/>Version ${APP_VERSION}</span>`);
  
  let legal = $(`<span class="mt-4 text-center"><a class="text-light" target="blank" href="https://help.stagevault.com/hc/2649884901">Help</a> &middot; <a class="text-light" target="blank" href="/legal/privacy-policy">Privacy Policy</a> &middot; <a class="text-light" target="blank" href="/legal/terms-of-use">Terms of Use</a></span>`);

  // Assemble the page
  loginNavItem.append(loginNavLink);
  signUpNavItem.append(signUpNavLink);
  nav.append(loginNavItem, signUpNavItem);
  loginTab.append(loginForm);
  signUpTab.append(signUpForm);
  tabContent.append(alertContainer, loginTab, signUpTab);
  col.append(logoContainer, nav, tabContent);
  row.append(col, legal, clientInfo);
  container.append(row);
  appContainer.append(container);
  renderAnnouncements(alertContainer);
  
  // Enable or disable the submit button based on whether all fields are filled
	function updateLoginButtonState() {
  		loginButton.prop('disabled', !loginEmailInput.val() || !loginPasswordInput.val());
	}
	
	function updateSignUpButtonState() {
	  const allFieldsFilled = signUpFirstNameInput.val() && signUpLastNameInput.val() && signUpEmailInput.val() && signUpPasswordInput.val();
	  const termsAgreed = $('#termsAgreement').is(':checked');
	
	  // Enable the button only if all fields are filled and terms are agreed to
	  signUpButton.prop('disabled', !(allFieldsFilled && termsAgreed));
	}
	
	// Bind both input and change — password managers and browser autofill
	// often fire only `change`, which used to leave the button disabled
	// after autofilling.
	loginEmailInput.on('input change', updateLoginButtonState);
	loginPasswordInput.on('input change', updateLoginButtonState);
	signUpFirstNameInput.on('input change', updateSignUpButtonState);
	signUpLastNameInput.on('input change', updateSignUpButtonState);
	signUpPasswordInput.on('input change', updateSignUpButtonState);
	$('#termsAgreement').on('change', updateSignUpButtonState);
	
	// Initialize the button states
	updateLoginButtonState();
	updateSignUpButtonState();

  // Email validation for the Sign Up form
  
  function isStudentEmail(email) {
	  return email.includes('student.brillion.k12.wi.us');
  }
  
  signUpEmailInput.on('input', function () {
  	updateSignUpButtonState();
	var email = $(this).val();
	if (isStudentEmail(email)) {
		$(this).addClass('is-invalid');
		showAlert("You cannot use a student email address. Those email accounts will be terminated after graduation. Please use a personal email address.", "danger");
	} else {
		$(this).removeClass('is-invalid');
	}
  });
  
  function isFormValid(form) {
	  return form.find('input').toArray().every(input => $(input).val());
	}
  
	function handleSubmit(form, handler) {
	  if (isFormValid(form)) {
		handler();
	  } else {
		showAlert('Please fill out all fields.', 'danger');
	  }
	}
  
	loginForm.on('submit', function (e) {
	  e.preventDefault(); // Prevent the default form submission behavior
	  handleSubmit($(this), () => loginUser(loginEmailInput.val(), loginPasswordInput.val()));
	});
  
	// ...
  
	signUpForm.on('submit', function (e) {
	  e.preventDefault(); // Prevent the default form submission behavior
	  handleSubmit($(this), () =>
		signUpUser(
		  signUpFirstNameInput.val(),
		  signUpLastNameInput.val(),
		  signUpEmailInput.val(),
		  signUpPasswordInput.val(),
		  $("#termsAgreement").is(':checked')
		)
	  );
	});
	
	function createPasswordResetModal() {
	  return $(`
		<div class="modal fade" id="passwordResetModal" tabindex="-1" aria-labelledby="passwordResetModalLabel" aria-hidden="true">
		  <div class="modal-dialog">
			<div class="modal-content">
			  <div class="modal-header">
				<h5 class="modal-title" id="passwordResetModalLabel">Reset Password</h5>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			  </div>
			  <div class="modal-body">
				<form id="passwordResetForm">
				  <div class="mb-3">
					<label for="emailAddress" class="form-label">Email Address</label>
					<input type="email" class="form-control" id="emailAddress" required>
				  </div>
				</form>
			  </div>
			  <div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				<button type="button" class="btn btn-primary" id="resetPasswordSubmitBtn">Reset Password</button>
			  </div>
			</div>
		  </div>
		</div>
	  `);
	}
	
        function promptPasswordReset() {
          const passwordResetModal = createPasswordResetModal();
          $("body").append(passwordResetModal);
	
	  const modalElement = document.getElementById("passwordResetModal");
	  const passwordResetModalInstance = new bootstrap.Modal(modalElement);
	  passwordResetModalInstance.show();
	
	  // Remove the modal from the DOM when it's closed
	  $(modalElement).on("hidden.bs.modal", function () {
		$(this).remove();
	  });
	}
	
	$(document).off("click", "#resetPasswordSubmitBtn").on("click", "#resetPasswordSubmitBtn", function () {
	  const emailAddress = $("#emailAddress").val();
	
	  // Validate the email address
          if (!emailAddress) {
                mkToast('account', 'danger', 'Error', 'Please enter your email address.');
                return;
          }
	
	  // Call your PHP script to handle the password reset request
          $.ajax({
                url: v1BaseUrl + "/auth/reset",
                method: "POST",
                svErrorMode: 'default',
                xhrFields: {
                  withCredentials: true
                },
		data: {
		  email: emailAddress,
		},
		success: function (response) {
		  if (response.success) {
			showAlert("Check your email inbox for a password reset link.");
		  } else {
			if (response.error !== null) {
				showAlert('Password reset error: ' + response.error);
			} else {
				showAlert("An error occurred while trying to request a password reset email.");
			}
		  }
		},
	  });
	
	  // Close the modal
	  const modalElement = document.getElementById("passwordResetModal");
	  const passwordResetModalInstance = bootstrap.Modal.getInstance(modalElement);
	  passwordResetModalInstance.hide();
	});
	
        forgotPasswordLink.on('click', function (e) {
          e.preventDefault();
          promptPasswordReset();
        });

        function promptDeviceLogin() {
          const existing = document.getElementById('deviceLoginModal');
          if (existing) {
            const inst = bootstrap.Modal.getInstance(existing);
            if (inst) inst.hide();
            existing.remove();
          }

          function formatTime(sec) {
            const m = String(Math.floor(sec / 60)).padStart(2, '0');
            const s = String(sec % 60).padStart(2, '0');
            return m + ':' + s;
          }

          let poll, countdown, refreshCooldown = false;

          function stopDeviceLoginTimers() {
            clearInterval(poll);
            clearInterval(countdown);
          }
          let guid, code;
          let active = false;

          function stopDeviceLoginTimers() {
            clearInterval(poll);
            clearInterval(countdown);
            refreshCooldown = false;
            active = false;
            $('#deviceLoginRefresh').prop('disabled', false);
          }

          async function start() {
            const res = await $.ajax({ url: v1BaseUrl + 'auth/deviceStart', type: 'POST', svErrorMode: 'default' });
            if (!res.success) return;
            active = true;
            guid = res.guid;
            code = res.code;
            renderModal();
            generateQR();
            startCountdown();
            startPoll();
          }

          function renderModal() {
            const modal = $(
              `<div class="modal fade" id="deviceLoginModal" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">Authorize on Another Device</h5>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-center">
                      <canvas id="deviceLoginQR" class="mb-3"></canvas>
                      <p class="mb-1">
                        Use your other device to scan this QR code or visit <b>${import.meta.env.CLIENT_HOSTNAME}/activate</b> and enter code
                        <strong id="deviceLoginCode" class="font-monospace">${code}</strong>
                        <button id="deviceLoginRefresh" class="btn btn-link p-0 ms-2" aria-label="Refresh" type="button">
                          <i class="bi-arrow-clockwise"></i>
                        </button>
                      </p>
                      <p class="text-secondary">Expires in <span id="deviceLoginTimer">05:00</span></p>
                      <p class="text-secondary">Waiting for authentication...</p>
                    </div>
                  </div>
                </div>
              </div>`);
            $('body').append(modal);
            const modalEl = document.getElementById('deviceLoginModal');
            const modalInstance = new bootstrap.Modal(modalEl);
            modalInstance.show();
            $('#deviceLoginRefresh').on('click', refreshCode);
            $(modalEl).on('hide.bs.modal', function(){
              stopDeviceLoginTimers();
            });
            $(modalEl).on('hidden.bs.modal', function(){
              $(this).remove();
            });
          }

          function generateQR() {
            const url = window.location.origin + '/activate?code=' + code;
            const canvas = document.getElementById('deviceLoginQR');
            QRCode.toCanvas(canvas, url, { width: 200 });
          }

          async function refreshCode() {
            if (!active || refreshCooldown) return;
            refreshCooldown = true;
            $('#deviceLoginRefresh').prop('disabled', true);
            setTimeout(() => {
              refreshCooldown = false;
              $('#deviceLoginRefresh').prop('disabled', false);
            }, 5000);

            stopDeviceLoginTimers();

            const res = await $.ajax({ url: v1BaseUrl + 'auth/deviceStart', type: 'POST', svErrorMode: 'default' });
            if (res.success) {
              guid = res.guid;
              code = res.code;
              $('#deviceLoginCode').text(code);
              generateQR();
              startCountdown();
              startPoll();
            }
          }

          function startCountdown() {
            let remaining = 300;
            $('#deviceLoginTimer').text(formatTime(remaining));
            countdown = setInterval(() => {
              remaining--;
              if (remaining <= 0) {
                clearInterval(countdown);
                refreshCode();
              } else {
                $('#deviceLoginTimer').text(formatTime(remaining));
              }
            }, 1000);
          }

          function restartCountdown() {
            clearInterval(countdown);
            startCountdown();
          }

          function startPoll() {
            poll = setInterval(() => {
              if (!active) {
                clearInterval(poll);
                return;
              }
              $.ajax({
                url: v1BaseUrl + 'auth/devicePoll',
                type: 'POST',
                svErrorMode: 'default',
                xhrFields: { withCredentials: true },
                data: { guid },
                success: function(pollRes) {
                  if(pollRes.success) {
                    stopDeviceLoginTimers();
                    const modalEl = document.getElementById('deviceLoginModal');
                    const instance = bootstrap.Modal.getInstance(modalEl);
                    instance.hide();
                    $(modalEl).remove();
                    // Route-driven render so a deep link survives the sign-in.
                    updateUserData().then(() => { applyRoute(); markLibraryRendered(); });
                  } else if(pollRes.denied) {
                    stopDeviceLoginTimers();
                    const modalEl = document.getElementById('deviceLoginModal');
                    const instance = bootstrap.Modal.getInstance(modalEl);
                    instance.hide();
                    $(modalEl).remove();
                    mkToast('device', 'danger', 'Denied', 'Authorization was denied.');
                  }
                }
              });
            }, 3000);
          }

          start();
        }

        if (deviceLoginLink) {
          deviceLoginLink.on('click', function(e) {
            e.preventDefault();
            promptDeviceLogin();
          });
        }

}


function loginUser(email, password, termsAgreed = false) {
  removeAlert();
  showLoader();

  $.ajax({
        url: v1BaseUrl + 'auth/signIn',
        type: 'POST',
        svErrorMode: 'none',
        xhrFields: {
          withCredentials: true
        },
	data: {
	  email: email,
	  password: password,
	  termsAgreed: termsAgreed  // Pass the termsAgreed flag
	},
	success: function(response) {
	  if (response.success) {
		updateUserData().then(() => {
                  if (window.location.search.includes('?rt=cms')) {
                        window.location.href = `https://${import.meta.env.CMS_HOSTNAME}`;
                  } else {
                        // Let the router render whatever the URL points at, so
                        // a deep link (e.g. /shows/abc) survives the sign-in.
                        applyRoute();
                        markLibraryRendered();
                  }
		}).catch((error) => {
		  showAlert(error);
		});
	  }
	},
	error: function(xhr) {
	  hideLoader();

	  // Show the error message if provided by the server
	  const errorMessage = xhr.responseJSON?.error || "An unexpected error occurred. Please try again.";

	  // Handle the case if the error relates to terms not being agreed
	  if (errorMessage === "You must agree to the Privacy Policy and Terms of Use before logging in.") {
		showAgreementModal(email, password);
	  } else {
		showAlert(errorMessage);  // Display the server-determined error message or fallback to generic
	  }

	  console.error('Error:', xhr.responseText);
	}
  });
}

function showAgreementModal(email, password) {
  // Create and show the modal for agreement
  var agreementModal = $(`
	<div class="modal fade" id="termsAgreementModal" tabindex="-1" aria-labelledby="termsAgreementLabel" aria-hidden="true">
	  <div class="modal-dialog">
		<div class="modal-content">
		  <div class="modal-header">
			<h5 class="modal-title" id="termsAgreementLabel">Agree to Terms</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		  </div>
		  <div class="modal-body">
		    <div class="alert bg-secondary text-light p-2 ps-3">
			  <i class="bi bi-calendar-check me-2"></i> Effective September 8, 2024
			</div>
			<p>You must agree to the <a href="/legal/privacy-policy" target="_blank">Privacy Policy</a> and <a href="/legal/terms-of-use" target="_blank">Terms of Use</a> to continue.</p>
			<div class="form-check">
			  <input type="checkbox" class="form-check-input" id="termsAgreementCheckbox" required>
			  <label class="form-check-label" for="termsAgreementCheckbox">
				I have read and agree to the Privacy Policy and Terms of Use.
			  </label>
			</div>
			<hr>
			<p>If you do not agree with these terms, please <a class="text-light" href="https://help.stagevault.com/hc/2649884901">open a support ticket</a> under the "Data Request" category to initiate the deletion of your account.</p>
		  </div>
		  <div class="modal-footer">
			<button type="button" class="btn btn-primary" id="agreeButton" disabled>Agree and Continue</button>
		  </div>
		</div>
	  </div>
	</div>
  `);

  $('body').append(agreementModal);
  var modal = new bootstrap.Modal(document.getElementById('termsAgreementModal'), {
	keyboard: false
  });
  modal.show();

  // Enable the "Agree and Continue" button when checkbox is checked
  $('#termsAgreementCheckbox').on('change', function() {
	$('#agreeButton').prop('disabled', !this.checked);
  });

  // Handle agreement submission
  $('#agreeButton').on('click', function() {
	if ($('#termsAgreementCheckbox').is(':checked')) {
	  // Retry login with termsAgreed set to true
	  loginUser(email, password, true);

	  // Hide the modal
	  modal.hide();

	  // Once the modal is fully hidden, remove the modal and backdrop from the DOM
	  $('#termsAgreementModal').on('hidden.bs.modal', function () {
		modal.dispose();  // Properly dispose of the modal
		$('#termsAgreementModal').remove();  // Remove modal from DOM
		$('.modal-backdrop').remove();  // Remove any remaining backdrop
	  });
	}
  });
}

export function updateUserData() {
        return new Promise((resolve, reject) => {
          const prevEmailVerified = userData.emailVerified;
          $.ajax({
                url: v1BaseUrl + 'account/info',
                type: 'GET',
                svErrorMode: 'default',
                xhrFields: {
                  withCredentials: true
                },
                success: function(response) {
                  if (response.success) {
                        userData = response.data;
                        if (prevEmailVerified === false && userData.emailVerified) {
                          // Email just verified on server; reload to refresh state
                          window.location.reload();
                        }
                        // Identify against both telemetry platforms — Sentry
                        // issues are unattributable without it.
                        identifyUser(userData);
                        resolve();
                  } else {
                        reject(response.error);
                  }
		},
		error: function(xhr, textStatus, errorThrown) {
		  const errorText = xhr.responseText;
		  console.error('Error:', errorText);
		  reject(errorText);
		},
	  });
	});
  }
  
function signUpUser(firstName, lastName, email, password, legalAgreement) {
	removeAlert();
	showLoader();
        $.ajax({
          url: v1BaseUrl + 'auth/signUp',
          type: 'POST',
          svErrorMode: 'none',
          xhrFields: {
                withCredentials: true
          },
	  data: {
		givenName: firstName,
		familyName: lastName,
		email: email,
		password: password,
	    termsAgreed: legalAgreement
	  },
	  success: function(response) {
		  updateUserData().then(() => {
                        if (response.success) {
                          // Route-driven render — keeps the URL authoritative.
                          applyRoute();
                          markLibraryRendered();
                        } else {
				hideLoader();
			  showAlert(response.error);
			}
		  }).catch((error) => {
			showAlert(response.error);
			hideLoader();
		  });
	  },
          error: function(xhr, textStatus, errorThrown) {
                  hideLoader();
                const errorText = xhr.responseJSON?.error || xhr.responseText || 'An unexpected error occurred.';
                console.error('Error:', errorText);
                showAlert(errorText);
          },
        });
  }
  
  export function logoutUser() {
          $.ajax({
                url: v1BaseUrl + 'auth/signOut', // Change this to the actual path of your PHP script
                type: 'GET',
                svErrorMode: 'default',
                xhrFields: {
                        withCredentials: true
                },
		success: function(response) {
                  if (response.success) {
                          resetUser();
                          promptSignIn();
                  } else {
			  mkToast("account", "danger", "Error", response.error, 15000);
		  }
		},
                error: function(xhr, textStatus, errorThrown) {
                  const errorText = xhr.responseText;
                  console.error('Error:', errorText);
                  mkToast('account', 'danger', 'Error', 'Error: ' + errorText);
                },
	  });
	}

function createUserSettingsModal() {
	  return $(`
		<div class="modal fade" id="settingsModal" tabindex="-1" aria-labelledby="settingsModalLabel" aria-hidden="true">
		  <div class="modal-dialog">
			<div class="modal-content">
			  <div class="modal-header">
				<h5 class="modal-title" id="settingsModalLabel">Account</h5>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			  </div>
			  <div class="modal-body">
				<form id="settingsForm">
				  <div class="mb-3">
					<label for="givenName" class="form-label">First Name</label>
					<input type="text" class="form-control" id="givenName" required>
				  </div>
				  <div class="mb-3">
					<label for="familyName" class="form-label">Last Name</label>
					<input type="text" class="form-control" id="familyName" required>
				  </div>
				  <div class="mb-3">
					<label for="email" class="form-label">Email</label>
					<input type="email" class="form-control" id="email" required>
					<span class="mt-1 fw-bold text-warning" id="emailUnverifiedWarning">This email address is not verified. If you recently changed your email, you can still sign in using your last verified email.</span>
				  </div>
				</form>
                                <a class="text-warning" id="exportDataBtn">Download My Data</a><br>
                                <span class="text-secondary" id="exportStatus" style="display:block"></span>
			  </div>
			  <div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				<button type="button" class="btn btn-primary" id="saveSettingsBtn">Save</button>
			  </div>
			</div>
		  </div>
		</div>
	  `);
	}

export function showSettings() {
	// Remove old
	if ($("#settingsModal").length == 1) {
		$("#settingsModal").remove();
	}
	
	const settingsModal = createUserSettingsModal();
	// Populate the fields with .val() so names/emails containing quotes
	// can't break the markup or inject attributes.
	settingsModal.find('#givenName').val(userData.givenName);
	settingsModal.find('#familyName').val(userData.familyName);
	settingsModal.find('#email').val(userData.email);
	$("body").append(settingsModal);
	
	const modalElement = $("#settingsModal");
	const settingsModalInstance = new bootstrap.Modal(modalElement);
	settingsModalInstance.show();
	

        const exportBtn = $("#exportDataBtn");
        const exportStatus = $("#exportStatus");

        function refreshExportStatus(showToast = false) {
                $.ajax({
                        url: v1BaseUrl + "account/exportStatus",
                        method: "GET",
                        svErrorMode: 'none',
                        xhrFields: { withCredentials: true },
                        success: function(resp) {
                          if (!resp.success) { return; }
                          exportStatus.text('');
                          const created = resp.created ? Date.parse(resp.created + 'Z') : 0;
                          const completed = resp.completed ? Date.parse(resp.completed + 'Z') : 0;
                          const withinDay = created && (Date.now() - created < 86400000);

                          if (withinDay) {
                                exportBtn.addClass('disabled').text('Export Requested');
                                exportStatus.text('You can only request one per day.');
                                if (showToast && resp.status === 'done') {
                                        mkToast('account', 'success', 'Export Ready', 'Check your email to download the file.', 15000);
                                }
                          } else {
                                exportBtn.removeClass('disabled').text('Download My Data');
                          }
                        }
                });
        }

        refreshExportStatus();

        exportBtn.off("click").on('click', function(event) {
                if (exportBtn.hasClass('disabled')) { return; }
                exportBtn.addClass('disabled').text('Requesting...');

                $.ajax({
                        url: v1BaseUrl + "account/export",
                        method: "POST",
                        svErrorMode: 'custom',
                        svErrorWhitelist: [429],
                        xhrFields: {
                          withCredentials: true
                        },
                        success: function(response) {
                          if (response.success) {
                                mkToast("account", "success", "Success", "We'll email you a link to download your data shortly.", 15000);
                                refreshExportStatus();
                          } else {
                                exportBtn.removeClass('disabled').text('Download My Data');
                                mkToast("account", "danger", "Error", "An error occurred while generating your export.", 15000);
                          }
                        },
                        error: function(xhr) {
                          exportBtn.removeClass('disabled').text('Download My Data');
                          let msg = 'An error occurred while generating your export.';
                          if (xhr.responseJSON && xhr.responseJSON.error) {
                                msg = xhr.responseJSON.error;
                          }
                          mkToast("account", "danger", "Error", msg, 15000);
                          refreshExportStatus();
                        }
                });
        });
	
	if (userData.emailVerified) {
		$("#emailUnverifiedWarning").addClass('d-none');
	} else {
		$("#emailUnverifiedWarning").removeClass('d-none');
	}
	
	
	$("#saveSettingsBtn").off("click").on('click', function(event) {
		saveUserSettings();
	});
	
	// Remove the modal from the DOM when it's closed. Native listener, not
	// jQuery: Bootstrap triggers the jQuery event before dispatching the
	// native one, so a jQuery-bound removal detaches the element and the
	// router's document-level hash-cleanup listener never fires, leaving
	// #settings stuck in the URL.
	  modalElement[0].addEventListener("hidden.bs.modal", function () {
		this.remove();
	  }, { once: true });
}

function saveUserSettings() {
  $.ajax({
        url: v1BaseUrl + "account/update",
        type: "POST",
        svErrorMode: 'none',
        xhrFields: {
          withCredentials: true
        },
	data: {
	  givenName: $("#givenName").val(),
	  familyName: $("#familyName").val(),
	  email: $("#email").val(),
	},
	success: function (response) {
	  if (response.success) {
		updateUserData().then(() => {
                  hideSettings();
                  // Route through the router so the URL and cached view stay
                  // in sync even when settings were opened from another page.
                  renderLibraryRoute("success", "Your account settings have been saved.");
                  markLibraryRendered();
		}).catch((error) => {
		  console.error("Error: " + error);
		});
          } else {
                console.error("Error: " + response.error);
                mkToast('account', 'danger', 'Error', response.error);
          }
	},
	error: function (xhr, textStatus, errorThrown) {
	  const errorText = xhr.responseText;
      if (xhr.responseJSON && xhr.responseJSON.success === false) {
        mkToast('account', 'danger', 'Error', xhr.responseJSON.error);
      }
	  console.error("Error:", errorText);
	},
  });
}

function hideSettings() {
  const modalElement = document.getElementById("settingsModal");
  const settingsModalInstance = bootstrap.Modal.getInstance(modalElement);
  settingsModalInstance.hide();
}

export function resendEmailConfirmation() {
        $("#resendEmailConfirmationBtn").addClass("disabled");
        $.ajax({
                url: v1BaseUrl + "auth/confirm",
                type: "GET",
                svErrorMode: 'none',
                xhrFields: {
                  withCredentials: true
                },
		success: function (response) {
		  if (response.success) {
			mkToast("account", "success", "Success", "We've successfully sent you another email confirmation link. Please follow the link we've sent to confirm your account.", 30000);
		  } else {
			mkToast("account", "danger", "Error", "An error occurred when we tried sending you a new verification email. Please try again in a few moments. If the issue persists, contact support@stagevault.com", 30000);
		  }
		},
		error: function (xhr, textStatus, errorThrown) {
		  const errorText = xhr.responseText;
          if (xhr.responseJSON && xhr.responseJSON.success === false) {
            mkToast('account', 'danger', 'Error', xhr.responseJSON.error);
          }
		  console.error("Error:", errorText);
		},
	  });
}